var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLightgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#8CA1B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03542 3.5778L8.42442 2.9668L6.00208 5.38913L3.57975 2.9668L2.96875 3.5778L5.39108 6.00013L2.96875 8.42247L3.57975 9.03347L6.00208 6.61113L8.42442 9.03347L9.03542 8.42247L6.61308 6.00013L9.03542 3.5778Z",
    fill: "#EFF3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightgrey);
export default __webpack_public_path__ + "static/media/close_lightgrey.cd6c1cdee6b13899689ad0db18ee49ac.svg";
export { ForwardRef as ReactComponent };